import { createIcon } from "@chakra-ui/icons";

export const CreateNewFolderIcon = createIcon({
  displayName: "CreateNewFolder",
  viewBox: "0 0 20 19",
  path: (
    <g>
      <path
        d="M14.25 11.1547V15.3452M12.1548 13.2499H16.3452M10.5833 8.53564H17.9167C18.4952 8.53564 18.9643 9.00468 18.9643 9.58326V16.9166C18.9643 17.4952 18.4952 17.9642 17.9167 17.9642H10.5833C10.0047 17.9642 9.53571 17.4952 9.53571 16.9166V9.58326C9.53571 9.00468 10.0047 8.53564 10.5833 8.53564Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.34961 0C6.5969 0 6.8289 0.122221 6.96875 0.326172L8.34473 2.33301H15.1504C15.7666 2.33311 16.3616 2.57134 16.8037 3.00098C17.2466 3.43157 17.4999 4.02035 17.5 4.63867V6.75H16V4.63867C15.9999 4.43218 15.9157 4.22986 15.7588 4.07715C15.601 3.92373 15.3824 3.83311 15.1504 3.83301H7.9502C7.70292 3.83301 7.47091 3.71174 7.33105 3.50781L5.95508 1.5H2.34961C2.11761 1.5001 1.89901 1.58975 1.74121 1.74316C1.58405 1.89597 1.5 2.09895 1.5 2.30566V13.1943C1.5 13.401 1.58405 13.604 1.74121 13.7568C1.89901 13.9103 2.11761 13.9999 2.34961 14H7.75V15.5H2.34961C1.73329 15.4999 1.1384 15.2618 0.696289 14.832C0.253342 14.4014 0 13.8127 0 13.1943V2.30566C0 1.68727 0.253342 1.09861 0.696289 0.667969C1.1384 0.238231 1.73329 0.000100462 2.34961 0H6.34961Z"
        fill="currentColor"
      />
    </g>
  ),
});
